import { Box, IconButton, Typography, Popover, Fade, SvgIcon } from "@material-ui/core";
import { List } from "@material-ui/core";
import { ArrowDownward, Close, EmojiObjects } from "@material-ui/icons";
import { FC, MutableRefObject } from "react";
import { useTranslation } from "react-i18next";

import { RelayAction } from "@/api/streamMetadata";
import LightsButtonItem from "@/common/components/streaming/ActionButtons/LightsButton/LightsButtonItem";
import { OpenButton } from "@/utilities/types/streaming";

import useStyles from "./LightsButton.styles";


interface LightsButtonProps {
    /**
     * Function to open and close button menus within the footer
     * @param button Name of the button
     */
    handleMenu: (button: OpenButton) => void;
    /**
     * Deduped list of lights from all cameras on a live unit
     */
    lights: RelayAction[];
    open: boolean;
    menuRef: MutableRefObject<null>;
}

const LightsButton: FC<LightsButtonProps> = ({ lights, handleMenu, open, menuRef }) => {
    const { t } = useTranslation("translation", { keyPrefix: "components.liveUnitMosaicPage.footer.buttons" });

    const maxHeight = lights.length > 4 ? 340 : undefined;
    const classes = useStyles({ maxHeight });

    return (
        <>
            <Box
                role="button"
                onClick={() => handleMenu(OpenButton.Lights)}
                display="flex"
                flexDirection="column"
                alignItems="center"
            >
                <SvgIcon className={classes.buttonIcon}>
                    <EmojiObjects />
                </SvgIcon>
                <Typography variant="caption">{t("lights")}</Typography>
            </Box>

            <Popover
                classes={{ paper: classes.popover }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                open={open}
                TransitionComponent={Fade}
                anchorEl={menuRef.current}
            >
                {/* Header */}
                <IconButton aria-label="close" onClick={() => handleMenu(OpenButton.None)} className={classes.close}>
                    <Close />
                </IconButton>
                <Typography className={classes.header}>{t("lights")}</Typography>

                {/* Content */}
                <List classes={{ root: classes.list }}>
                    {lights.map((light) => (
                        <LightsButtonItem key={light.uiLabel} light={light} disableGutters />
                    ))}
                </List>

                {/* Footer */}
                {maxHeight &&
                    <div className={classes.listFooter}>
                        <ArrowDownward />
                    </div>
                }
            </Popover>
        </>
    );
};

export default LightsButton;
